<template>
  <div class="right-fix-draw-wrapper">
    <div class="draw-mask" @click="closeMobileSideBar"></div>
    <div class="draw-page">
      <el-scrollbar class="draw-page-scrollbar" >
        <slot></slot>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import drawMenu from '@/components/menu'
export default {
  name:'rightdraw',
  components:{
    drawMenu
  },
  computed:{ },
  methods:{
    ...mapMutations({
      'CloseToolBar':'app/CloseToolBar'
    }),
    closeMobileSideBar(){
      this.CloseToolBar()
    }
  }
}
</script>
<style lang="scss" scoped>
.right-fix-draw-wrapper{
  width: 100%;
  position: fixed;
  top: 54px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  display: flex;
  .draw-page{
    box-sizing: border-box;
    padding: 5px;
    flex: 2;
    width: 240px;
    height: 100%;  
    border-top: 1px solid #dddddd;
    background: #fff;
    overflow: hidden;
    z-index: 102;
    .draw-page-scrollbar{
      width: 100%;
      height: 100%;
    }
  }
  .draw-mask{
    flex: 1;
    z-index: 102;
  }
}
</style>


